import React from 'react';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { ContextMenuOption, ContextMenuState } from '../../models/misc/context-menu';

const CustomContextMenu: React.FC<{
  contextMenuOptions: ContextMenuOption[];
  contextMenuState: ContextMenuState | null;
  onClose: () => void;
}> = ({ contextMenuOptions, contextMenuState, onClose }) => {
  if (contextMenuState == null) return null;

  return (
    <React.Fragment>
      <Menu
        open={contextMenuState !== null}
        onClose={onClose}
        sx={{ px: 1 }}
        anchorReference="anchorPosition"
        anchorPosition={
          contextMenuState !== null
            ? { top: contextMenuState.mouseY - 26, left: contextMenuState.mouseX + 8 }
            : undefined
        }
        slotProps={{
          root: {
            onContextMenu: (event: React.MouseEvent) => {
              event.preventDefault();
              onClose();
            },
          },
        }}
      >
        {contextMenuOptions.map((option) => (
          <MenuItem
            key={option.title}
            onClick={() => {
              option.action(contextMenuState.id);
              onClose();
            }}
            sx={{ mx: 1, borderRadius: 2 }}
          >
            <Stack spacing={1} direction="row" alignItems="center">
              {option.icon != null && option.icon}
              <Typography variant="body2">{option.title}</Typography>
            </Stack>
          </MenuItem>
        ))}
      </Menu>
    </React.Fragment>
  );
};

export default CustomContextMenu;
